<div
  class="sidebar"
  [class.collapsed]="isCollapsed && !isExpanded"
  [class.expanded]="isExpanded"
>
  <div class="sidebar-header">
    <!-- Botón toggle visible solo en modo colapsado -->
    @if (isCollapsed) {
    <div class="toggle-button-container">
      <button class="toggle-button" (click)="toggleSidebar()">
        <i
          class="bi"
          [ngClass]="isExpanded ? 'bi-chevron-left' : 'bi-list'"
        ></i>
      </button>
    </div>
    }
    <div class="brand-logo">
      @if (isCollapsed) { @if (isDarkMode) {
      <img
        (click)="navigateAndClose('/home', false)"
        src="/assets/logo-m-b.png"
        alt="Logo"
      />
      } @else {
      <img
        (click)="navigateAndClose('/home', false)"
        src="/assets/logo-m.png"
        alt="Logo"
      />
      } } @else { @if (isDarkMode) {
      <img
        (click)="navigateAndClose('/home', false)"
        src="/assets/logo-b.png"
        alt="Logo"
      />
      } @else {
      <img
        (click)="navigateAndClose('/home', false)"
        src="/assets/logo.png"
        alt="Logo"
      />
      } }
    </div>
  </div>

  <div class="sidebar-menu">
    <div class="menu-items">
      @for (item of menuItems; track item.name; let i = $index) {
      <div class="menu-item-container">
        <div
          class="menu-item"
          [class.active]="expandedItemIndex === i"
          [class.has-subitems]="hasSubItems(item)"
          [class.menu-item-has-active-subitem]="item.hasActiveSubitem"
          (click)="
            hasSubItems(item)
              ? toggleSubMenu(i)
              : navigateAndClose(item.route, false)
          "
          [routerLink]="hasSubItems(item) ? null : [item.route]"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="menu-item-content">
            <i class="bi bi-{{ item.icon }} item-icon"></i>
            <p class="item-text">{{ item.name }}</p>
          </div>
          @if (hasSubItems(item)) {
          <i
            class="bi bi-chevron-down submenu-arrow"
            [class.rotated]="expandedItemIndex === i"
          ></i>
          }
        </div>

        @if (hasSubItems(item) && expandedItemIndex === i) {
        <div class="submenu open">
          @for (subItem of item.subItems; track subItem.name; let j = $index) {
          <a
            class="submenu-item"
            [class.active]="isSubitemActive(subItem)"
            [routerLink]="[subItem.route]"
            (click)="
              $event.preventDefault(); navigateAndClose(subItem.route, true)
            "
            [routerLinkActiveOptions]="{ exact: false }"
            routerLinkActive="active"
            [attr.style]="'--item-index: ' + j"
          >
            @if (subItem.icon) {
            <i class="bi bi-{{ subItem.icon }}"></i>
            }
            <span class="submenu-text">{{ subItem.name }}</span>
          </a>
          }
        </div>
        }
      </div>
      }
    </div>
  </div>

  <div class="sidebar-footer">
    <!-- Toggle para modo oscuro -->
    <a class="menu-item">
      <app-button
        type="neutral"
        [icon]="isDarkMode ? 'sun' : 'moon'"
        (onClick)="toggleDarkMode()"
        ngbTooltip="Cambiar tema"
        placement="right"
        [openDelay]="300"
        [container]="'body'"
      />
    </a>

    <a class="menu-item">
      <app-toggle
        #tableViewToggle
        [checked]="isTableView"
        (onChange)="handleTableViewChange($event)"
        option1="grid"
        option2="table"
      />
    </a>
    <a
      class="menu-item"
      routerLink="/home/settings"
      routerLinkActive="active"
      (click)="navigateAndClose('/home/settings', false)"
    >
      <div class="menu-item-content">
        <i class="bi bi-gear item-icon"></i>
        <span class="item-text">Configuración</span>
      </div>
    </a>
    <a class="menu-item" (click)="onLogoutClick()">
      <div class="menu-item-content">
        <i class="bi bi-box-arrow-right item-icon"></i>
        <span class="item-text">Cerrar sesión</span>
      </div>
    </a>
  </div>
</div>

<!-- Modal de confirmación para modo tabla -->
<app-ext-modal
  [visible]="showTableModeModal"
  [title]="'Activar la vista clasica'"
  [paragraph]="
    'Activar la vista clásica mostrará los datos en tabla, afectando la vista de dispositivos móviles y tablets.'
  "
  [type]="'dude'"
  [confirmText]="'Activar'"
  [cancelText]="'Cancelar'"
  (onConfirm)="confirmTableMode()"
  (onCancel)="cancelTableMode()"
  (onClose)="cancelTableMode()"
/>
